import type { SchemaInput } from './schema-input.js';
import { isString } from './runtime-values.js';
export const COMPETITOR_SOURCES = ['google_my_maps', 'scribble_maps', 'maptive'] as const;
export const COMPETITOR_CHANNELS = ['organic_content', 'paid_search', 'community'] as const;

export type CompetitorSource = typeof COMPETITOR_SOURCES[number];
export type CompetitorChannel = typeof COMPETITOR_CHANNELS[number];

export const COMPETITOR_SOURCE_VALUES = new Set<string>(COMPETITOR_SOURCES);
export const COMPETITOR_CHANNEL_VALUES = new Set<string>(COMPETITOR_CHANNELS);
export const COMPETITOR_LANDING_PAGES = [
  '/blog/draw-on-google-maps/',
  '/blog/scribble-maps-alternative/',
  '/blog/maptive-alternative/',
] as const;
export const COMPETITOR_LANDING_PAGE_VALUES = new Set<string>(COMPETITOR_LANDING_PAGES);

export function cleanCompetitorSource(value: SchemaInput): CompetitorSource | null {
  // SAFETY: The adjacent allowlist, normalizer, or equality check limits this value to the stated union.
  return isString(value) && COMPETITOR_SOURCE_VALUES.has(value) ? value as CompetitorSource : null;
}

export function cleanCompetitorChannel(value: SchemaInput): CompetitorChannel | null {
  // SAFETY: The adjacent allowlist, normalizer, or equality check limits this value to the stated union.
  return isString(value) && COMPETITOR_CHANNEL_VALUES.has(value) ? value as CompetitorChannel : null;
}

export function cleanCompetitorLandingPage(value: SchemaInput): string | null {
  return isString(value) && COMPETITOR_LANDING_PAGE_VALUES.has(value) ? value : null;
}
